import { render } from "./disciplinaEditar.vue?vue&type=template&id=101b27d2"
import script from "./disciplinaEditar.vue?vue&type=script&lang=js"
export * from "./disciplinaEditar.vue?vue&type=script&lang=js"

import "./disciplinaEditar.vue?vue&type=style&index=0&id=101b27d2&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__